
document.querySelectorAll('.img-rollover-text .expand-icons').forEach((button) => {
  button.addEventListener('click', function () {

    const item = this.closest('.img-rollover-text');

    item.classList.toggle('active');
  });
});


gsap.registerPlugin(SplitText, ScrollTrigger);


document.querySelectorAll(".typing-split, .collection-title-view-format h3").forEach((element) => {
  const split = new SplitText(element, {
    type: "words,chars"
  });

  gsap.from(split.chars, {
    scrollTrigger: {
      trigger: element,
      start: "top 80%",
      toggleActions: "play none none none",
      once: true,
    onEnter: () => {
      gsap.to(element.querySelectorAll("a"), {
        opacity: 1,
        delay: split.chars.length * 0.01,
        duration: 0.1
      });
    }
    },
    opacity: 0,
    duration: 0.1,
    stagger: 0.01,
    ease: "power2.out"
  });

});

// Gradient-bar Animation
gsap.utils.toArray(".hhs-gradient-bar").forEach((bar) => {
  gsap.fromTo(
    bar,
    {
      scaleX: 0,
      transformOrigin: "left center"
    },
    {
      scaleX: 1,
      duration: 2,
      ease: "power1.inOut",
      scrollTrigger: {
        trigger: bar,
        start: "top 85%",
        once: true
      }
    }
  );
});




// Parallax Animation

gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(".shopify-section").forEach((section) => {
  const inner = section.querySelector(".parallax");

  if (!inner) return;

  gsap.fromTo(
    inner,
    {
      yPercent: -40,      
    },
    {
      yPercent: 40,      
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: "top bottom",
        end: "bottom top",
        scrub: true, // smoother than true
        invalidateOnRefresh: true
      }
    }
  );
});
